import { globalStatus } from '../state/app-state.js';

export function mountProgressBar(parent: HTMLElement): void {
  const bar = document.createElement('div');
  bar.className = 'global-status';
  bar.innerHTML = `<span class="global-status-spinner"></span><span class="global-status-msg"></span>`;
  parent.append(bar);
  const msg = bar.querySelector<HTMLSpanElement>('.global-status-msg')!;
  globalStatus.subscribe((s) => {
    msg.textContent = s.message;
    bar.classList.toggle('is-visible', s.busy);
  });
}
